import React, { useMemo } from 'react';
import clsx from 'clsx';

import { Divider, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBackOutlined';

import Menu from '../menu/Menu';
import Header from '../header/Header';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './PageContainer.styles';
import theme from '../../../styles/theme';

interface PageContainerProps {
  children: React.ReactNode;
  title?: string;
  backPath?: string;
  backButton?: boolean;
  headerContent?: React.ReactNode;
}

const PageContainer = (props: PageContainerProps) => {
  const { children, title, backPath, backButton, headerContent } = props;
  const navigate = useNavigate();
  const { classes } = useStyles(theme);

  const header = useMemo(() => {
    return (
      <div className={classes.pageContainerHeader}>
        {(title || backPath || backButton) && (
          <div
            className={clsx(
              classes.pageContainerTitle,
              (backPath || backButton) && classes.clickable,
            )}
            onClick={() =>
              (backButton || backPath) && navigate((backPath || -1) as any)
            }>
            {(backPath || backButton) && <ArrowBackIcon />}
            <Typography variant="h2" className={classes.title}>
              {title}
            </Typography>
          </div>
        )}
        {headerContent}
      </div>
    );
  }, [headerContent, title, backPath, backButton]);

  return (
    <main className={classes.pageWrapper}>
      <Header>{null}</Header>
      <div className={classes.pageContainerWrapper}>
        <Menu />
        <div className={classes.pageContainer}>
          <div>{header}</div>
          <div className={classes.divider}>
            {(title || backPath || headerContent) && <Divider />}
          </div>
          <div className={classes.pageContainerContent}>{children}</div>
        </div>
      </div>
    </main>
  );
};

export default PageContainer;
